<template>
  <div class="rank-container">
    <div class="cl-card">
      <div class="rank">
        <div class="icon">
          <img src="/static/images/ic-info-school.svg" alt="school-rank">
        </div>
        <div class="stats">
          <div class="rank-title">{{ $t('common.rank') }}</div>
          <div class="rank-stats">
            <template v-if="isSchoolTotal">
              <strong>{{ rateScore(schoolRate) }}%</strong>
              <div class="changed" v-if="changedSchoolRate !== 0">
                <img :src="`/static/images/${changedRateResource(changedSchoolRate).icon}`" alt="changed-score">
                <span v-bind:style="{ 'color': changedRateResource(changedSchoolRate).color }">{{ changedRateScore(changedSchoolRate) }}%</span>
              </div>
            </template>
            <strong v-else>-%</strong>
          </div>
          <div class="rank-standard">
            <template v-if="isSchoolTotal">{{ schoolName }} {{ $t('common.standard') }}</template>
            <template v-else>{{ $t('common.standard_before_update') }}</template>
          </div>
        </div>
      </div>

      <div class="rank">
        <div class="icon">
          <img src="/static/images/ic-info-location.svg" alt="school-rank">
        </div>
        <div class="stats">
          <div class="rank-title">{{ $t('common.rank') }}</div>
          <div class="rank-stats">
            <template v-if="isDistrictTotal">
              <strong>{{ rateScore(districtRate) }}%</strong>
              <div class="changed" v-if="changedDistrictRate !== 0">
                <img :src="`/static/images/${changedRateResource(changedDistrictRate).icon}`" alt="changed-score">
                <span v-bind:style="{ 'color': changedRateResource(changedDistrictRate).color }">{{ changedRateScore(changedDistrictRate) }}%</span>
              </div>
            </template>
            <strong v-else>-%</strong>
          </div>
          <div class="rank-standard">
            <template v-if="isDistrictTotal">{{ regionName }} {{ $t('common.standard') }}</template>
            <template v-else>{{ $t('common.standard_before_update') }}</template>
          </div>
        </div>
      </div>

      <div class="rank">
        <div class="icon">
          <img src="/static/images/ic-info-grade.svg" alt="school-rank">
        </div>
        <div class="stats">
          <div class="rank-title">{{ $t('common.rank') }}</div>
          <div class="rank-stats">
            <template v-if="isGradeTotal">
              <strong>{{ rateScore(gradeRate) }}%</strong>
              <div class="changed" v-if="changedGradeRate !== 0">
                <img :src="`/static/images/${changedRateResource(changedGradeRate).icon}`" alt="changed-score">
                <span v-bind:style="{ 'color': changedRateResource(changedGradeRate).color }">{{ changedRateScore(changedGradeRate) }}%</span>
              </div>
            </template>
            <strong v-else>-%</strong>
          </div>
          <div class="rank-standard">
            <template v-if="isGradeTotal">{{ $t('proficiency.standard') }}</template>
            <template v-else>{{ $t('common.standard_before_update') }}</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { round } from 'lodash';

  export default {
    name: 'cat-proficiency-rank',

    computed: {
      ...mapGetters({
        isGradeTotal: 'isGradeTotal',
        isSchoolTotal: 'isSchoolTotal',
        schoolName: 'getSchoolName',
        gradeRate: 'getGradeRate',
        schoolRate: 'getSchoolRate',
        changedSchoolRate: 'getChangedSchoolRate',
        changedGradeRate: 'getChangedGradeRate',
        changedDistrictRate: 'getChangedDistrictRate',
        regionName: 'getRegionName',
        districtRate: 'getDistrictRate',
        prevDistrictRate: 'getPrevDistrictRate',
        isDistrictTotal: 'isDistrictTotal',
      }),

    },

    methods: {
      changedRateResource(changedRate) {
        if (changedRate < 0) {
          return {
            icon: 'ic-info-decrease.svg',
            color: '#448aff',
          };
        }

        return {
          icon: 'ic-info-increase.svg',
          color: '#ff595f',
        };
      },

      rateScore(score) {
        return round(Math.abs(score), 1);
      },

      changedRateScore(score) {
        return round(Math.abs(score));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .rank-container {
    .rank {
      display: inline-block;
      padding: 24px 14px 24px 14px;
      width: 32%;

      .stats {
        .rank-title {
          color: rgba(0, 0, 0, 0.87);
          padding-top: 8px;
          font-size: 12px;
        }

        .rank-stats {
          color: rgba(0, 0, 0, 0.8);
          padding: 0 0 6px 0;
          font-size: 20px;
          font-weight: bold;

          .changed {
            display: inline-block;
            font-size: 14px;
          }
        }

        .rank-standard {
          white-space: nowrap;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatProficiencyRank.vue?3bb31602